var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.375,
    height: 13,
    viewBox: "0 0 11.375 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-alt",
    d: "M.812,11.781A1.219,1.219,0,0,0,2.031,13H9.344a1.219,1.219,0,0,0,1.219-1.219V3.25H.812Zm6.906-6.5a.406.406,0,1,1,.812,0v5.687a.406.406,0,1,1-.812,0Zm-2.437,0a.406.406,0,0,1,.813,0v5.687a.406.406,0,1,1-.812,0Zm-2.437,0a.406.406,0,1,1,.812,0v5.687a.406.406,0,1,1-.812,0ZM10.969.812H7.922L7.683.338A.609.609,0,0,0,7.137,0h-2.9a.6.6,0,0,0-.543.338L3.453.812H.406A.406.406,0,0,0,0,1.219v.812a.406.406,0,0,0,.406.406H10.969a.406.406,0,0,0,.406-.406V1.219A.406.406,0,0,0,10.969.812Z",
    transform: "translate(0 0)",
    fill: "#f44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7aa09bef5b3b7a850cb76c6d2f6e2c04.svg";
export { ForwardRef as ReactComponent };